import "./piva-ordinaria.4e8012e8.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9dryX", function(module, exports) {

$parcel$export(module.exports, "getComuneSelezionato", () => $6b5ab55d30331bca$export$3e7c72272eb1c22e);
$parcel$export(module.exports, "initComuneAutocomplete", () => $6b5ab55d30331bca$export$e4a5c0d41dd66a05);
// Autocomplete del comune per l'addizionale comunale IRPEF.
// I dati (generati da scripts/build-addizionali-comunali.js, fonte MEF) sono
// divisi per regione e caricati on-demand alla selezione della regione, cosi'
// il bundle principale non cresce.
//
// Il selettore e' un combobox custom (input + dropdown gestita da noi) invece
// del <datalist> nativo: quest'ultimo ha comportamenti incoerenti tra browser
// e soprattutto su mobile (a volte non compare, filtra diversamente, non si
// puo' stilizzare). Il combobox custom funziona in modo identico ovunque e
// supporta tastiera, mouse e touch.
// Le chiavi corrispondono alle option del select #regione. Import literal per
// permettere a Parcel il code splitting.





















const $6b5ab55d30331bca$var$REGIONE_LOADERS = {
    'Abruzzo': ()=>(parcelRequire("cVJ7L")),
    'Basilicata': ()=>(parcelRequire("3Vig3")),
    'Bolzano': ()=>(parcelRequire("be8H4")),
    'Calabria': ()=>(parcelRequire("iFFpZ")),
    'Campania': ()=>(parcelRequire("8vE1O")),
    'Emilia-Romagna': ()=>(parcelRequire("8zAUd")),
    'Friuli Venezia-Giulia': ()=>(parcelRequire("gyxoc")),
    'Lazio': ()=>(parcelRequire("kRhAd")),
    'Liguria': ()=>(parcelRequire("7u9n8")),
    'Lombardia': ()=>(parcelRequire("7CiPK")),
    'Marche': ()=>(parcelRequire("8BLqv")),
    'Molise': ()=>(parcelRequire("3ccGn")),
    'Piemonte': ()=>(parcelRequire("dYw3h")),
    'Puglia': ()=>(parcelRequire("jPuI6")),
    'Sardegna': ()=>(parcelRequire("e7TnA")),
    'Sicilia': ()=>(parcelRequire("iTVKm")),
    'Toscana': ()=>(parcelRequire("1y8kQ")),
    'Trento': ()=>(parcelRequire("eVGdJ")),
    'Umbria': ()=>(parcelRequire("45a6i")),
    "Valle d'Aosta": ()=>(parcelRequire("hJIAG")),
    'Veneto': ()=>(parcelRequire("fmao9"))
};
// Massimo numero di risultati mostrati nella dropdown: per regioni con
// migliaia di comuni evita liste ingestibili e DOM inutilmente grande.
const $6b5ab55d30331bca$var$MAX_RISULTATI = 50;
const $6b5ab55d30331bca$var$etichettaComune = ([nome, pr])=>`${nome} (${pr})`;
// Normalizza per il confronto: rimuove accenti e maiuscole cosi' "forli"
// trova "Forli'" e la ricerca e' insensibile ad accenti/maiuscole.
const $6b5ab55d30331bca$var$normalizza = (s)=>s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
// Aliquota mostrata nel campo percentuale: per i comuni a scaglioni si usa
// l'aliquota massima come riferimento visivo; il calcolo vero usa gli scaglioni.
const $6b5ab55d30331bca$var$aliquotaIndicativa = (record)=>{
    const valore = record[2];
    if (Array.isArray(valore)) return Math.max(...valore.map(([, a])=>a));
    return valore;
};
let $6b5ab55d30331bca$var$comuniCorrenti = new Map(); // etichetta -> record [nome, pr, aliquota|scaglioni, esenzione]
let $6b5ab55d30331bca$var$recordsCorrenti = []; // stessi record in array, per il filtro della dropdown
let $6b5ab55d30331bca$var$selezione = null;
let $6b5ab55d30331bca$var$impostazioneProgrammatica = false;
function $6b5ab55d30331bca$export$3e7c72272eb1c22e() {
    if (!$6b5ab55d30331bca$var$selezione) return null;
    const [nome, pr, valore, esenzione] = $6b5ab55d30331bca$var$selezione;
    return {
        nome: `${nome} (${pr})`,
        esenzione: esenzione,
        scaglioni: Array.isArray(valore) ? valore : null,
        aliquota: Array.isArray(valore) ? null : valore
    };
}
function $6b5ab55d30331bca$export$e4a5c0d41dd66a05() {
    const regioneSelect = document.getElementById('regione');
    const comuneInput = document.getElementById('comune');
    const dropdown = document.getElementById('comuni-list');
    const aliquotaInput = document.getElementById('addizionale-comunale');
    const nota = document.getElementById('comune-note');
    if (!regioneSelect || !comuneInput || !dropdown || !aliquotaInput) return;
    const percentuale = (n)=>`${n.toFixed(2).replace('.', ',')}%`;
    const euro = (n)=>`${n.toLocaleString('it-IT')} \u{20AC}`;
    // -- Stato della dropdown --------------------------------------------------
    let risultati = []; // record attualmente mostrati
    let attivo = -1; // indice dell'opzione evidenziata (tastiera)
    let aperta = false;
    let chiudiTimer = null;
    const aggiornaNota = ()=>{
        if (!nota) return;
        if (!$6b5ab55d30331bca$var$selezione) {
            nota.textContent = "Seleziona il tuo comune: l'addizionale comunale ufficiale viene applicata in automatico.";
            return;
        }
        const [, , valore, esenzione] = $6b5ab55d30331bca$var$selezione;
        const testoAliquota = Array.isArray(valore) ? `Addizionale comunale a scaglioni, fino allo ${percentuale($6b5ab55d30331bca$var$aliquotaIndicativa($6b5ab55d30331bca$var$selezione))}` : `Addizionale comunale: ${percentuale(valore)}`;
        const testoEsenzione = esenzione > 0 ? `, esente fino a ${euro(esenzione)} di imponibile` : '';
        nota.textContent = `${testoAliquota}${testoEsenzione}. Fonte MEF.`;
    };
    const azzeraSelezione = ()=>{
        $6b5ab55d30331bca$var$selezione = null;
        comuneInput.classList.remove('comune-riconosciuto');
        // il campo aliquota non e' piu' visibile: senza comune torna al default
        $6b5ab55d30331bca$var$impostazioneProgrammatica = true;
        aliquotaInput.value = '0.80';
        aliquotaInput.dispatchEvent(new Event('change'));
        $6b5ab55d30331bca$var$impostazioneProgrammatica = false;
        aggiornaNota();
    };
    const applicaSelezione = (record)=>{
        $6b5ab55d30331bca$var$selezione = record;
        $6b5ab55d30331bca$var$impostazioneProgrammatica = true;
        aliquotaInput.value = $6b5ab55d30331bca$var$aliquotaIndicativa(record).toFixed(2);
        aliquotaInput.dispatchEvent(new Event('change'));
        $6b5ab55d30331bca$var$impostazioneProgrammatica = false;
        comuneInput.classList.add('comune-riconosciuto');
        aggiornaNota();
    };
    // -- Dropdown custom -------------------------------------------------------
    const chiudi = ()=>{
        if (!aperta) return;
        aperta = false;
        dropdown.classList.add('hidden');
        dropdown.replaceChildren();
        comuneInput.setAttribute('aria-expanded', 'false');
        comuneInput.removeAttribute('aria-activedescendant');
        attivo = -1;
        risultati = [];
    };
    const filtra = (query)=>{
        const nq = $6b5ab55d30331bca$var$normalizza(query);
        if (!nq) return $6b5ab55d30331bca$var$recordsCorrenti.slice(0, $6b5ab55d30331bca$var$MAX_RISULTATI);
        const iniziano = [];
        const contengono = [];
        for (const record of $6b5ab55d30331bca$var$recordsCorrenti){
            const nome = $6b5ab55d30331bca$var$normalizza(record[0]);
            const idx = nome.indexOf(nq);
            if (idx === 0) iniziano.push(record);
            else if (idx > 0) contengono.push(record);
        }
        return iniziano.concat(contengono).slice(0, $6b5ab55d30331bca$var$MAX_RISULTATI);
    };
    const evidenzia = (indice)=>{
        const opzioni = dropdown.children;
        if (attivo >= 0 && opzioni[attivo]) opzioni[attivo].classList.remove('active');
        attivo = indice;
        const opzione = opzioni[attivo];
        if (opzione) {
            opzione.classList.add('active');
            comuneInput.setAttribute('aria-activedescendant', opzione.id);
            opzione.scrollIntoView({
                block: 'nearest'
            });
        } else comuneInput.removeAttribute('aria-activedescendant');
    };
    const scegli = (record)=>{
        comuneInput.value = $6b5ab55d30331bca$var$etichettaComune(record);
        applicaSelezione(record);
        chiudi();
    };
    const mostra = ()=>{
        if (comuneInput.disabled) return;
        risultati = filtra(comuneInput.value);
        dropdown.replaceChildren();
        attivo = -1;
        if (!risultati.length) {
            const vuoto = document.createElement('li');
            vuoto.className = 'comune-empty';
            vuoto.textContent = 'Nessun comune trovato';
            dropdown.appendChild(vuoto);
        } else {
            const frammento = document.createDocumentFragment();
            risultati.forEach((record, i)=>{
                const opzione = document.createElement('li');
                opzione.className = 'comune-option';
                opzione.id = `comune-opt-${i}`;
                opzione.setAttribute('role', 'option');
                opzione.dataset.indice = String(i);
                const spanNome = document.createElement('span');
                spanNome.className = 'comune-nome';
                spanNome.textContent = record[0];
                const spanPr = document.createElement('span');
                spanPr.className = 'comune-pr';
                spanPr.textContent = `(${record[1]})`;
                opzione.append(spanNome, spanPr);
                frammento.appendChild(opzione);
            });
            dropdown.appendChild(frammento);
        }
        dropdown.classList.remove('hidden');
        comuneInput.setAttribute('aria-expanded', 'true');
        aperta = true;
    };
    const caricaRegione = async (regione)=>{
        $6b5ab55d30331bca$var$comuniCorrenti = new Map();
        $6b5ab55d30331bca$var$recordsCorrenti = [];
        chiudi();
        const loader = $6b5ab55d30331bca$var$REGIONE_LOADERS[regione];
        if (!loader) {
            comuneInput.disabled = true;
            comuneInput.placeholder = 'Seleziona prima la regione';
            return;
        }
        try {
            const modulo = await loader();
            const dati = modulo?.default ?? modulo;
            $6b5ab55d30331bca$var$recordsCorrenti = dati.comuni;
            for (const record of dati.comuni)$6b5ab55d30331bca$var$comuniCorrenti.set($6b5ab55d30331bca$var$etichettaComune(record), record);
            comuneInput.disabled = false;
            comuneInput.placeholder = 'Cerca il tuo comune...';
            // ripristino da URL condiviso: se il campo ha gia' un valore, riabbina
            if (comuneInput.value) riconosciComune();
        } catch (err) {
            // dati non disponibili: il campo manuale resta pienamente funzionante
            console.error('addizionali comunali non caricate', err);
            comuneInput.disabled = true;
        }
    };
    // Riconosce un comune quando il testo digitato corrisponde esattamente a
    // un'etichetta (es. ripristino da URL o testo incollato); altrimenti azzera.
    const riconosciComune = ()=>{
        const record = $6b5ab55d30331bca$var$comuniCorrenti.get(comuneInput.value.trim());
        if (record) applicaSelezione(record);
        else azzeraSelezione();
    };
    // -- Eventi ----------------------------------------------------------------
    regioneSelect.addEventListener('change', ()=>{
        azzeraSelezione();
        comuneInput.value = '';
        caricaRegione(regioneSelect.value);
    });
    comuneInput.addEventListener('input', ()=>{
        riconosciComune();
        mostra();
    });
    comuneInput.addEventListener('change', riconosciComune);
    comuneInput.addEventListener('focus', ()=>{
        if (chiudiTimer) {
            clearTimeout(chiudiTimer);
            chiudiTimer = null;
        }
        mostra();
    });
    // Chiusura al blur con piccolo ritardo, cosi' il tap/click su un'opzione
    // (che avviene dopo il blur su alcuni dispositivi) fa in tempo a registrarsi.
    comuneInput.addEventListener('blur', ()=>{
        chiudiTimer = setTimeout(chiudi, 150);
    });
    comuneInput.addEventListener('keydown', (e)=>{
        if (!aperta && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
            mostra();
            e.preventDefault();
            return;
        }
        if (!aperta) return;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                if (risultati.length) evidenzia((attivo + 1) % risultati.length);
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (risultati.length) evidenzia((attivo - 1 + risultati.length) % risultati.length);
                break;
            case 'Enter':
                if (attivo >= 0 && risultati[attivo]) {
                    e.preventDefault();
                    scegli(risultati[attivo]);
                }
                break;
            case 'Escape':
                chiudi();
                break;
            default:
                break;
        }
    });
    // mousedown sul contenitore: preventDefault mantiene il focus sull'input
    // (evita che il blur chiuda la lista prima del click). La selezione avviene
    // sul click, che scatta anche dopo un tap su touch ma non dopo uno scroll.
    dropdown.addEventListener('mousedown', (e)=>e.preventDefault());
    dropdown.addEventListener('click', (e)=>{
        const opzione = e.target.closest('.comune-option');
        if (!opzione) return;
        const record = risultati[Number(opzione.dataset.indice)];
        if (record) scegli(record);
    });
    // modifica manuale dell'aliquota = override: il calcolo torna alla
    // percentuale flat inserita dall'utente
    aliquotaInput.addEventListener('input', ()=>{
        if (!$6b5ab55d30331bca$var$impostazioneProgrammatica) azzeraSelezione();
    });
    // regione gia' valorizzata al load (es. ritorno dalla pagina risultati)
    if (regioneSelect.value) caricaRegione(regioneSelect.value);
    aggiornaNota();
}

});
parcelRegister("cVJ7L", function(module, exports) {
module.exports = import("12og1").then(()=>parcelRequire('gyh4v'));

});

parcelRegister("3Vig3", function(module, exports) {
module.exports = import("l4RBo").then(()=>parcelRequire('bm7vg'));

});

parcelRegister("be8H4", function(module, exports) {
module.exports = import("3qwqS").then(()=>parcelRequire('bmLtN'));

});

parcelRegister("iFFpZ", function(module, exports) {
module.exports = import("k9rMK").then(()=>parcelRequire('gl2v3'));

});

parcelRegister("8vE1O", function(module, exports) {
module.exports = import("5OhFn").then(()=>parcelRequire('gyIrk'));

});

parcelRegister("8zAUd", function(module, exports) {
module.exports = import("bRX4y").then(()=>parcelRequire('cJnkM'));

});

parcelRegister("gyxoc", function(module, exports) {
module.exports = import("eBKHC").then(()=>parcelRequire('1mE4K'));

});

parcelRegister("kRhAd", function(module, exports) {
module.exports = import("jZXl3").then(()=>parcelRequire('4whM3'));

});

parcelRegister("7u9n8", function(module, exports) {
module.exports = import("1guQx").then(()=>parcelRequire('24dlK'));

});

parcelRegister("7CiPK", function(module, exports) {
module.exports = import("40Ogq").then(()=>parcelRequire('i0yNS'));

});

parcelRegister("8BLqv", function(module, exports) {
module.exports = import("eP9kT").then(()=>parcelRequire('i3UXt'));

});

parcelRegister("3ccGn", function(module, exports) {
module.exports = import("iNAJS").then(()=>parcelRequire('3LsOL'));

});

parcelRegister("dYw3h", function(module, exports) {
module.exports = import("gFoGw").then(()=>parcelRequire('25eg0'));

});

parcelRegister("jPuI6", function(module, exports) {
module.exports = import("h8r5O").then(()=>parcelRequire('dQFZY'));

});

parcelRegister("e7TnA", function(module, exports) {
module.exports = import("2gPOJ").then(()=>parcelRequire('h0pZD'));

});

parcelRegister("iTVKm", function(module, exports) {
module.exports = import("fpWp6").then(()=>parcelRequire('7R8Ur'));

});

parcelRegister("1y8kQ", function(module, exports) {
module.exports = import("j82Qr").then(()=>parcelRequire('2Y2Wd'));

});

parcelRegister("eVGdJ", function(module, exports) {
module.exports = import("8f7KR").then(()=>parcelRequire('e4vmD'));

});

parcelRegister("45a6i", function(module, exports) {
module.exports = import("cRm0J").then(()=>parcelRequire('lOvps'));

});

parcelRegister("hJIAG", function(module, exports) {
module.exports = import("dwQ6O").then(()=>parcelRequire('b33WV'));

});

parcelRegister("fmao9", function(module, exports) {
module.exports = import("4ZLfe").then(()=>parcelRequire('2SMUf'));

});


parcelRegister("jzqAH", function(module, exports) {

$parcel$export(module.exports, "computeNetto", () => $e3f5e99d078f5d67$export$8fd1bf637c479d0f);
// Catena completa RAL -> stipendio netto, in una sola funzione pura.
//
// Questa e' la sola implementazione dell'orchestrazione: prima viveva in tre
// copie (computeFromParams in js/script.js, scripts/lib/calcolo-netto.js e una
// copia locale nei golden test). Chi calcola un netto - la UI del calcolatore,
// il solver inverso, i generatori di pagine, i test - passa da qui.
//
// Nessuna dipendenza dal DOM: `mensilita` va sempre passata esplicitamente,
// perche' employee.calculateRetribuzioneMensileNetta altrimenti la cerca in
// pagina. La sequenza e' congelata dai golden test (tests/netto-golden.test.js):
// se cambia qui, quei valori devono essere ricontrollati a mano.

var $3ItrY = parcelRequire("3ItrY");
function $e3f5e99d078f5d67$export$8fd1bf637c479d0f(data, params = {}) {
    const year = params.year || '2026';
    const mensilita = Number(params.mensilita) || 14;
    const ral = Number(params.ral) || 0;
    const alinpsDip = params.alinpsDip ?? data.aliquote_inps.lavoratore.regolare * 100;
    const alinpsDat = params.alinpsDat ?? data.aliquote_inps.azienda.regolare * 100;
    const massimale = data.aliquote_inps[`massimale${year}`] || data.aliquote_inps.massimale2026;
    const imponibileInpsBase = Math.min(ral, massimale);
    const { inpsDipendente: inpsDipendente, inpsAzienda: inpsAzienda } = $3ItrY.calculateInps(imponibileInpsBase, data, {
        year: year,
        esoneroContributivo: params.esoneroContributivo ?? false,
        madreLavoratrice: params.madreLavoratrice ?? false,
        mensilita: mensilita,
        apprendistato: params.apprendistato ?? false,
        alinpsDip: alinpsDip,
        alinpsDat: alinpsDat
    });
    const imponibileIrpef = $3ItrY.calculateImponibileIrpef(ral, inpsDipendente, {
        rientroCervelli: params.rientroCervelli ?? false,
        imponibileCervelli: params.imponibileCervelli ?? 1
    });
    // Reddito complessivo al lordo dello sconto impatriati: e' la base delle
    // soglie di bonus 100, bonus cuneo e ulteriore detrazione, che per legge
    // includono per intero la quota esente. Coincide con l'imponibile negli
    // altri casi.
    const redditoComplessivo = ral - inpsDipendente;
    const irpefLorda = $3ItrY.calculateIrpef(imponibileIrpef, data, {
        year: year
    });
    const detrazioneLavoro = $3ItrY.calculateDetrazioniIrpef(imponibileIrpef, {
        ral: ral
    });
    const detrazioneConiuge = $3ItrY.calculateDetrazioneConiuge(imponibileIrpef, {
        coniugeCarico: params.coniugeCarico ?? false
    });
    const detrazioneFigli = $3ItrY.calculateDetrazioneFigli(imponibileIrpef, {
        numeroFigli: params.figliCarico === false ? 0 : params.numeroFigli ?? 0,
        numeroFigliDisabili: params.numeroFigliDisabili ?? 0,
        percentualeFigli: params.percentualeFigli ?? 100
    });
    const detrazioneAscendenti = $3ItrY.calculateDetrazioneAscendenti(imponibileIrpef, {
        // Spuntare "ascendenti a carico" senza indicarne il numero vale 1.
        numeroAscendenti: params.ascendenteCarico ? params.numeroAscendenti || 1 : params.ascendenteCarico === false ? 0 : params.numeroAscendenti ?? 0
    });
    const ulterioreDetrazione = $3ItrY.calculateUlterioreDetrazione(ral, inpsDipendente, {
        cuneoFiscale: params.cuneoFiscale ?? true
    });
    const irpefNetta = $3ItrY.calculateIrpefNetta(irpefLorda, detrazioneLavoro, detrazioneConiuge, ulterioreDetrazione, detrazioneFigli, detrazioneAscendenti);
    const addizionaleRegionale = $3ItrY.calculateAddizionaleRegionale(imponibileIrpef, data, irpefNetta, {
        regione: params.regione || '',
        year: year
    });
    const addizionaleComunale = $3ItrY.calculateAddizionaleComunale(imponibileIrpef, irpefNetta, {
        addizionaleComunale: params.addizionaleComunale ?? 0,
        esenzione: params.comuneEsenzione ?? 0,
        scaglioni: params.comuneScaglioni ?? null
    });
    const bonus100 = $3ItrY.calculateBonus100(imponibileIrpef, detrazioneLavoro, irpefLorda, detrazioneConiuge, ulterioreDetrazione, {
        bonus100Flag: params.bonus100Flag ?? true,
        altreDetrazioni: params.altreDetrazioni ?? 0,
        detrazioneFigli: detrazioneFigli,
        detrazioneAscendenti: detrazioneAscendenti,
        redditoComplessivo: redditoComplessivo
    });
    const sommaIntegrativa = $3ItrY.calculateSommaIntegrativa(imponibileIrpef, {
        cuneoFiscale: params.cuneoFiscale ?? true,
        redditoComplessivo: redditoComplessivo
    });
    const totaleIrpef = $3ItrY.calculateTotaleIrpef(irpefNetta, addizionaleComunale, addizionaleRegionale);
    const nettoAnnuo = $3ItrY.calculateRetribuzioneAnnuaNetta(ral, inpsDipendente, totaleIrpef, sommaIntegrativa, bonus100);
    const nettoMensileMedio = $3ItrY.calculateRetribuzioneMensileNetta(nettoAnnuo, {
        mensilita: mensilita
    });
    const ripartizione = $3ItrY.calculateNettoMensilita(nettoAnnuo, {
        ral: ral,
        inpsDipendente: inpsDipendente,
        irpefLorda: irpefLorda,
        irpefNetta: irpefNetta,
        addizionaleRegionale: addizionaleRegionale,
        addizionaleComunale: addizionaleComunale,
        sommaIntegrativa: sommaIntegrativa,
        bonus100: bonus100
    }, {
        mensilita: mensilita
    });
    const trattamentoFineRapporto = Math.round(ral / 13.5);
    const inail = $3ItrY.calculateInail(ral, data);
    const costoAzienda = Math.round(ral + trattamentoFineRapporto + inpsAzienda + inail);
    return {
        ral: ral,
        mensilita: mensilita,
        inpsDipendente: inpsDipendente,
        inpsAzienda: inpsAzienda,
        imponibileIrpef: imponibileIrpef,
        irpefLorda: irpefLorda,
        detrazioneLavoro: detrazioneLavoro,
        detrazioneConiuge: detrazioneConiuge,
        detrazioneFigli: detrazioneFigli,
        detrazioneAscendenti: detrazioneAscendenti,
        ulterioreDetrazione: ulterioreDetrazione,
        irpefNetta: irpefNetta,
        addizionaleRegionale: addizionaleRegionale,
        addizionaleComunale: addizionaleComunale,
        bonus100: bonus100,
        sommaIntegrativa: sommaIntegrativa,
        totaleIrpef: totaleIrpef,
        nettoAnnuo: nettoAnnuo,
        nettoMensileMedio: nettoMensileMedio,
        // Con 12 mensilita' non esiste una mensilita' aggiuntiva: ordinaria = media.
        nettoMensilitaOrdinaria: ripartizione?.nettoMensilitaOrdinaria ?? nettoMensileMedio,
        nettoMensilitaAggiuntiva: ripartizione?.nettoMensilitaAggiuntiva ?? null,
        trattamentoFineRapporto: trattamentoFineRapporto,
        inail: inail,
        costoAzienda: costoAzienda
    };
}

});

parcelRegister("cMIZ9", function(module, exports) {
module.exports = import("9yWLR").then(()=>parcelRequire('2AVDS'));

});

parcelRegister("jFNsA", function(module, exports) {
module.exports = Promise.all([
    import("4Kwaw"),
    import("d6xcJ")
]).then(()=>parcelRequire('2GTA0'));

});

// Calcolatore inverso: dal netto desiderato alla RAL da chiedere.
//
// Due pagine, come il calcolatore del netto: /calcolo-lordo-da-netto raccoglie
// i dati, /calcolo-lordo-da-netto/risultati li legge dalla query string (JSON
// in base64, stesso formato del resto del sito) e mostra il risultato. Lo stato
// vive nell'URL, quindi il permalink e la condivisione funzionano senza codice
// dedicato.
//
// La matematica sta altrove: js/nettoEngine.js per la catena RAL -> netto e
// js/solveRal.js per l'inversione.

var $cNJzb = parcelRequire("cNJzb");

var $9dryX = parcelRequire("9dryX");

var $jzqAH = parcelRequire("jzqAH");
// Calcolo inverso: da un netto desiderato alla RAL da chiedere.
//
// Il netto NON e' una funzione monotona della RAL. Su ogni soglia normativa
// che si chiude di colpo - esenzione dell'addizionale comunale, trattamento
// integrativo a 15.000 di imponibile, scaglioni della somma integrativa, la
// maggiorazione di 65 euro fra 25.000 e 35.000 - il netto scende mentre il
// lordo sale. Di conseguenza alcuni netti non sono raggiungibili da nessuna
// RAL, e una bisezione (che presuppone la monotonia) restituisce risultati
// sbagliati.
//
// Qui si cerca quindi per scansione la RAL MINIMA che raggiunge il target:
// una passata grossolana per individuare la zona, poi una passata a un euro
// sulle celle candidate. tests/lordo-da-netto.test.js verifica il risultato
// contro una scansione esaustiva.

var $jzqAH = parcelRequire("jzqAH");
const $6bbba1924fc499b5$var$PASSO_GROSSOLANO = 100;
// Sporgenza massima di un picco interno a una cella rispetto ai suoi estremi:
// e' limitata da PASSO_GROSSOLANO per la pendenza massima del netto, che non
// supera 1 euro per euro di RAL. Misurata a 97 euro/anno; qui si tiene un
// margine quadruplo. Serve a non saltare il picco stretto che precede una
// soglia (l'ultimo euro sotto l'esenzione comunale, per esempio).
const $6bbba1924fc499b5$var$MARGINE_ANNUO = 4 * $6bbba1924fc499b5$var$PASSO_GROSSOLANO;
const $6bbba1924fc499b5$var$RAL_MASSIMA = 1000000;
// Perdita minima, in euro di netto annuo, perche' un calo conti come soglia.
// Le detrazioni che decrescono in modo continuo, arrotondate all'euro,
// producono di continuo cali da un euro: sono rumore, non soglie. I salti veri
// valgono almeno 60 euro.
const $6bbba1924fc499b5$var$PERDITA_MINIMA = 20;
const $6bbba1924fc499b5$export$88b745e7b36e49bc = [
    'busta',
    'medio',
    'annuo'
];
function $6bbba1924fc499b5$export$ee40bac03751f76c(breakdown, modo = 'busta') {
    if (modo === 'annuo') return breakdown.nettoAnnuo;
    if (modo === 'medio') return breakdown.nettoMensileMedio;
    return breakdown.nettoMensilitaOrdinaria;
}
// Confronta due punti a cavallo di una discontinuita' e dice quale beneficio
// si e' perso. Nessuna soglia hardcoded: si guarda cosa e' cambiato davvero,
// cosi' la spiegazione resta valida per qualsiasi comune e configurazione.
function $6bbba1924fc499b5$var$descriviSoglia(prima, dopo) {
    const cause = [];
    if (dopo.bonus100 < prima.bonus100) cause.push('si perde il trattamento integrativo (il "bonus" da 1.200 euro)');
    if (dopo.sommaIntegrativa < prima.sommaIntegrativa) cause.push('cala la somma integrativa da riduzione del cuneo fiscale');
    if (prima.addizionaleComunale === 0 && dopo.addizionaleComunale > 0) cause.push('si supera la soglia di esenzione dell\'addizionale comunale');
    if (dopo.detrazioneLavoro < prima.detrazioneLavoro) cause.push('si riduce la detrazione da lavoro dipendente');
    if (dopo.ulterioreDetrazione < prima.ulterioreDetrazione) cause.push('cala l\'ulteriore detrazione per il cuneo fiscale');
    return cause;
}
function $6bbba1924fc499b5$export$5174eaaeb10a35c0(data, params = {}, { target: target, modo: modo = 'busta' } = {}) {
    const mensilita = Number(params.mensilita) || 14;
    const netto = (ral)=>(0, $jzqAH.computeNetto)(data, {
            ...params,
            ral: ral
        });
    const f = (ral)=>$6bbba1924fc499b5$export$ee40bac03751f76c(netto(ral), modo);
    const targetAnnuo = modo === 'annuo' ? target : target * mensilita;
    const margine = modo === 'annuo' ? $6bbba1924fc499b5$var$MARGINE_ANNUO : Math.ceil($6bbba1924fc499b5$var$MARGINE_ANNUO / mensilita);
    // A redditi bassi il netto puo' superare il lordo (cuneo piu' trattamento
    // integrativo): con 8.000 di RAL il netto e' 8.981. Da qui il margine sotto.
    const minimo = Math.max(0, Math.floor(targetAnnuo - 4000));
    const massimo = Math.min($6bbba1924fc499b5$var$RAL_MASSIMA, Math.ceil(targetAnnuo * 2.5 + 20000));
    let trovata = null;
    const valoreIniziale = f(minimo);
    if (valoreIniziale >= target) trovata = minimo;
    else {
        // Passata grossolana, fino alla prima cella che attraversa il target.
        const celle = [];
        let griglia = minimo;
        let valorePrec = valoreIniziale;
        while(griglia < massimo){
            const successivo = Math.min(griglia + $6bbba1924fc499b5$var$PASSO_GROSSOLANO, massimo);
            const valore = f(successivo);
            celle.push({
                da: griglia,
                a: successivo,
                max: Math.max(valorePrec, valore)
            });
            if (valore >= target) break;
            griglia = successivo;
            valorePrec = valore;
        }
        // Raffinamento a un euro. Si riesamina l'ultima cella - quella che
        // attraversa il target - e ogni cella precedente il cui massimo agli
        // estremi resta entro il margine: e' li' che puo' nascondersi il picco
        // stretto che precede una soglia.
        for(let i = 0; i < celle.length; i++){
            const cella = celle[i];
            if (i !== celle.length - 1 && cella.max + margine < target) continue;
            for(let ral = cella.da; ral <= cella.a; ral++)if (f(ral) >= target) {
                trovata = ral;
                break;
            }
            if (trovata !== null) break;
        }
    }
    if (trovata === null) {
        const breakdown = netto(massimo);
        return {
            ral: null,
            breakdown: breakdown,
            nettoEffettivo: $6bbba1924fc499b5$export$ee40bac03751f76c(breakdown, modo),
            esatto: false,
            fuoriPortata: true,
            plateau: null,
            soglie: [],
            euroMarginale: null
        };
    }
    const breakdown = netto(trovata);
    const nettoEffettivo = $6bbba1924fc499b5$export$ee40bac03751f76c(breakdown, modo);
    // Plateau: quante RAL diverse danno esattamente questo netto. Sapere che
    // chiedere 39.720 invece di 39.700 non cambia nulla in busta e' informazione
    // vera e utile in trattativa.
    let plateauMax = trovata;
    while(plateauMax < massimo && f(plateauMax + 1) === nettoEffettivo)plateauMax++;
    // Soglie attraversate nei 3.000 euro di RAL sotto la soluzione: servono a
    // spiegare perche' il netto richiesto costa piu' lordo del previsto.
    const soglie = [];
    let precedente = null;
    for(let ral = Math.max(0, trovata - 3000); ral <= trovata; ral += 1){
        const corrente = netto(ral);
        const perdita = precedente ? precedente.nettoAnnuo - corrente.nettoAnnuo : 0;
        if (perdita >= $6bbba1924fc499b5$var$PERDITA_MINIMA) {
            const cause = $6bbba1924fc499b5$var$descriviSoglia(precedente, corrente);
            if (cause.length) soglie.push({
                ral: ral,
                perdita: perdita,
                cause: cause
            });
        }
        precedente = corrente;
    }
    // Resa dell'euro lordo marginale, su 1.000 euro di RAL in piu'.
    const conMille = netto(Math.min(trovata + 1000, $6bbba1924fc499b5$var$RAL_MASSIMA));
    const euroMarginale = {
        nettoAnnuoInPiu: conMille.nettoAnnuo - breakdown.nettoAnnuo,
        nettoInPiu: $6bbba1924fc499b5$export$ee40bac03751f76c(conMille, modo) - nettoEffettivo,
        resa: (conMille.nettoAnnuo - breakdown.nettoAnnuo) / 1000
    };
    return {
        ral: trovata,
        breakdown: breakdown,
        nettoEffettivo: nettoEffettivo,
        esatto: nettoEffettivo === target,
        fuoriPortata: false,
        plateau: {
            min: trovata,
            max: plateauMax
        },
        soglie: soglie,
        euroMarginale: euroMarginale
    };
}


// I grafici (e con loro d3) si caricano solo sulla pagina dei risultati:
// il form usa lo stesso modulo e non deve pagarne il peso.
const $771f671a260a0b00$var$percorso = window.location.pathname.replace(/\/+$/, '');
const $771f671a260a0b00$var$isRisultati = $771f671a260a0b00$var$percorso === '/calcolo-lordo-da-netto/risultati' || $771f671a260a0b00$var$percorso === '/calcolo-lordo-da-netto/risultati/index.html';
const $771f671a260a0b00$var$REGIONI = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($cNJzb))).aliquote_regionali['2026']);
const $771f671a260a0b00$var$numero = (v)=>new Intl.NumberFormat('it-IT', {
        maximumFractionDigits: 0
    }).format(Math.round(v));
const $771f671a260a0b00$var$euro = (v)=>`${$771f671a260a0b00$var$numero(v)} \u{20AC}`;
// Un decimale, ma "40,0%" si scrive "40%".
const $771f671a260a0b00$var$percento = (v)=>`${v.toFixed(1).replace(/\.0$/, '').replace('.', ',')}%`;
const $771f671a260a0b00$var$encodeParams = (obj)=>btoa(encodeURIComponent(JSON.stringify(obj)));
const $771f671a260a0b00$var$decodeParams = (s)=>{
    try {
        return JSON.parse(decodeURIComponent(atob(s)));
    } catch  {
        return null;
    }
};
const $771f671a260a0b00$var$parseBool = (v)=>v === '1' || v === 1 || v === true || v === 'true';
const $771f671a260a0b00$var$bool = (v, predefinito)=>v === undefined || v === '' ? predefinito : $771f671a260a0b00$var$parseBool(v);
const $771f671a260a0b00$var$ETICHETTE_MODO = {
    busta: 'netto in busta, mese ordinario',
    medio: 'netto medio mensile',
    annuo: 'netto annuo'
};
// ---------------------------------------------------------------------------
// Parametri
// ---------------------------------------------------------------------------
// Dai campi del form all'oggetto da mettere in URL.
function $771f671a260a0b00$var$raccogliParametri() {
    const obj = {};
    const set = (k, v)=>{
        if (v !== undefined && v !== null && v !== '') obj[k] = v;
    };
    const val = (id)=>document.getElementById(id)?.value || '';
    const checked = (id)=>document.getElementById(id)?.checked ?? false;
    set('netto', val('netto-target'));
    set('modo', document.querySelector('input[name="modo"]:checked')?.value || 'busta');
    set('regione', val('regione'));
    set('mensilita', document.querySelector('input[name="mensilita"]:checked')?.value || '14');
    set('year', document.querySelector('input[name="year"]:checked')?.value || '2026');
    set('addizionaleComunale', val('addizionale-comunale'));
    const comune = (0, $9dryX.getComuneSelezionato)();
    if (comune) {
        set('comune', comune.nome);
        if (comune.esenzione > 0) set('comuneEsenzione', comune.esenzione);
        if (comune.scaglioni) obj.comuneScaglioni = comune.scaglioni;
    }
    set('alinpsDip', val('alinps-dip'));
    set('alinpsDat', val('alinps-dat'));
    set('altreDetrazioni', val('altre-detrazioni'));
    set('imponibileCervelli', val('imponibile-cervelli'));
    if (checked('figli-carico')) {
        set('numeroFigli', val('numero-figli'));
        set('numeroFigliDisabili', val('numero-figli-disabili'));
        set('percentualeFigli', val('percentuale-figli'));
    }
    if (checked('ascendente-carico')) set('numeroAscendenti', val('numero-ascendenti'));
    const flag = [
        [
            'cuneo-fiscale',
            'cuneoFiscale'
        ],
        [
            'esonero-contributivo',
            'esoneroContributivo'
        ],
        [
            'madre-lavoratrice',
            'madreLavoratrice'
        ],
        [
            'bonus-100',
            'bonus100'
        ],
        [
            'apprendistato',
            'apprendistato'
        ],
        [
            'dipendente-pubblico',
            'dipendentePubblico'
        ],
        [
            'maggiore-15',
            'maggiore15'
        ],
        [
            'modifica-inps',
            'modificaInps'
        ],
        [
            'coniuge-carico',
            'coniugeCarico'
        ],
        [
            'figli-carico',
            'figliCarico'
        ],
        [
            'ascendente-carico',
            'ascendenteCarico'
        ],
        [
            'rientro-cervelli',
            'rientroCervelli'
        ]
    ];
    for (const [id, nome] of flag){
        const el = document.getElementById(id);
        if (el) obj[nome] = el.checked ? '1' : '0';
    }
    return obj;
}
// Dall'URL ai parametri di computeNetto/solveRal.
function $771f671a260a0b00$var$leggiParametri() {
    const query = new URLSearchParams(window.location.search);
    const grezzi = query.has('d') ? $771f671a260a0b00$var$decodeParams(query.get('d')) : Object.fromEntries(query);
    if (!grezzi) return null;
    const target = Math.round(parseFloat(grezzi.netto) || 0);
    if (target <= 0) return null;
    const modo = $771f671a260a0b00$var$ETICHETTE_MODO[grezzi.modo] ? grezzi.modo : 'busta';
    return {
        target: target,
        modo: modo,
        grezzi: grezzi,
        params: {
            regione: grezzi.regione || '',
            mensilita: parseInt(grezzi.mensilita, 10) || 14,
            year: grezzi.year || '2026',
            addizionaleComunale: parseFloat(grezzi.addizionaleComunale) || 0,
            comuneEsenzione: parseFloat(grezzi.comuneEsenzione) || 0,
            comuneScaglioni: Array.isArray(grezzi.comuneScaglioni) ? grezzi.comuneScaglioni : null,
            alinpsDip: grezzi.alinpsDip !== undefined ? parseFloat(grezzi.alinpsDip) : undefined,
            alinpsDat: grezzi.alinpsDat !== undefined ? parseFloat(grezzi.alinpsDat) : undefined,
            altreDetrazioni: parseFloat(grezzi.altreDetrazioni) || 0,
            imponibileCervelli: parseFloat(grezzi.imponibileCervelli) || 1,
            // Un link scritto a mano puo' non contenere le spunte: in quel caso
            // valgono i default del form, non "tutto disattivato".
            cuneoFiscale: $771f671a260a0b00$var$bool(grezzi.cuneoFiscale, true),
            bonus100Flag: $771f671a260a0b00$var$bool(grezzi.bonus100, true),
            esoneroContributivo: $771f671a260a0b00$var$bool(grezzi.esoneroContributivo, false),
            madreLavoratrice: $771f671a260a0b00$var$bool(grezzi.madreLavoratrice, false),
            apprendistato: $771f671a260a0b00$var$bool(grezzi.apprendistato, false),
            coniugeCarico: $771f671a260a0b00$var$bool(grezzi.coniugeCarico, false),
            figliCarico: $771f671a260a0b00$var$bool(grezzi.figliCarico, (parseInt(grezzi.numeroFigli, 10) || 0) > 0),
            numeroFigli: parseInt(grezzi.numeroFigli, 10) || 0,
            numeroFigliDisabili: parseInt(grezzi.numeroFigliDisabili, 10) || 0,
            percentualeFigli: parseFloat(grezzi.percentualeFigli) || 100,
            ascendenteCarico: $771f671a260a0b00$var$bool(grezzi.ascendenteCarico, (parseInt(grezzi.numeroAscendenti, 10) || 0) > 0),
            numeroAscendenti: parseInt(grezzi.numeroAscendenti, 10) || 0,
            rientroCervelli: $771f671a260a0b00$var$bool(grezzi.rientroCervelli, false)
        }
    };
}
// Parametri per il calcolatore del netto, cosi' il passaggio di consegne
// riapre lo stesso profilo con la RAL trovata.
function $771f671a260a0b00$var$parametriPerCalcolatoreNetto(grezzi, ral) {
    const { netto: netto, modo: modo, ...resto } = grezzi;
    return $771f671a260a0b00$var$encodeParams({
        ...resto,
        ral: String(ral)
    });
}
// ---------------------------------------------------------------------------
// Pagina del form
// ---------------------------------------------------------------------------
function $771f671a260a0b00$var$initForm() {
    const nettoInput = document.getElementById('netto-target');
    const regione = document.getElementById('regione');
    const bottone = document.getElementById('calcolaButton');
    const alinpsDip = document.getElementById('alinps-dip');
    const alinpsDat = document.getElementById('alinps-dat');
    const inpsBlock = document.getElementById('aliquote-inps');
    const modificaInps = document.getElementById('modifica-inps');
    const dipendentePubblico = document.getElementById('dipendente-pubblico');
    const apprendistato = document.getElementById('apprendistato');
    const maggiore15 = document.getElementById('maggiore-15');
    // Aliquote INPS derivate dalle spunte, con la stessa precedenza del
    // calcolatore del netto: modifica manuale, pubblico, apprendistato, oltre 15.
    // In ripristino da URL le aliquote sono gia' state scritte dai parametri
    // salvati: `mantieniValori` evita di sovrascriverle con quelle di profilo.
    const sincronizzaInps = ({ mantieniValori: mantieniValori = false } = {})=>{
        const q = (0, (/*@__PURE__*/$parcel$interopDefault($cNJzb))).aliquote_inps;
        if (modificaInps?.checked) {
            inpsBlock?.classList.remove('hidden-block');
            if (dipendentePubblico) dipendentePubblico.checked = false;
            if (apprendistato) apprendistato.checked = false;
            if (maggiore15) maggiore15.checked = false;
        } else if (mantieniValori && alinpsDip?.value && alinpsDat?.value) inpsBlock?.classList.add('hidden-block');
        else {
            inpsBlock?.classList.add('hidden-block');
            let dip = q.lavoratore.regolare;
            let dat = q.azienda.regolare;
            if (dipendentePubblico?.checked) {
                dip = q.lavoratore.pubblico;
                dat = q.azienda.pubblico;
            } else if (apprendistato?.checked) {
                dip = q.lavoratore.apprendistato;
                dat = q.azienda.apprendistato;
            } else if (maggiore15?.checked) {
                dip = q.lavoratore.quindici_dipendenti;
                dat = q.azienda.regolare;
            }
            if (alinpsDip) alinpsDip.value = (dip * 100).toFixed(2);
            if (alinpsDat) alinpsDat.value = (dat * 100).toFixed(2);
        }
        aggiornaStatoBottone();
    };
    // Le quattro spunte sulle aliquote si escludono a vicenda.
    const esclusive = [
        modificaInps,
        dipendentePubblico,
        apprendistato,
        maggiore15
    ];
    esclusive.forEach((el)=>{
        el?.addEventListener('change', ()=>{
            if (el.checked) esclusive.forEach((altro)=>{
                if (altro !== el) altro.checked = false;
            });
            sincronizzaInps();
        });
    });
    // Blocchi condizionali
    const mostraSe = (checkboxId, blockId)=>{
        const checkbox = document.getElementById(checkboxId);
        const blocco = document.getElementById(blockId);
        const applica = ()=>blocco?.classList.toggle('hidden-block', !checkbox?.checked);
        checkbox?.addEventListener('change', ()=>{
            applica();
            aggiornaStatoBottone();
        });
        applica();
    };
    mostraSe('figli-carico', 'figli-dettagli');
    mostraSe('ascendente-carico', 'ascendenti-dettagli');
    mostraSe('rientro-cervelli', 'cervelli-percentage');
    // Le detrazioni per oneri contano solo per incapienza, fra 15.000 e 28.000
    // di imponibile: si mostra il campo solo quando la RAL stimata ci finisce.
    const aggiornaAltreDetrazioni = ()=>{
        const riga = document.getElementById('altre-detrazioni-row');
        if (!riga) return;
        const bonusAttivo = document.getElementById('bonus-100')?.checked;
        const target = parseFloat(nettoInput?.value) || 0;
        const mensilita = parseInt(document.querySelector('input[name="modo"]:checked')?.value === 'annuo' ? 1 : document.querySelector('input[name="mensilita"]:checked')?.value, 10) || 14;
        const nettoAnnuoStimato = target * mensilita;
        // approssimazione volutamente grossolana: serve solo a decidere se mostrare
        // il campo, il calcolo vero avviene sulla pagina risultati
        const imponibileStimato = nettoAnnuoStimato * 1.15;
        riga.classList.toggle('hidden-block', !(bonusAttivo && imponibileStimato > 15000 && imponibileStimato <= 28000));
    };
    document.getElementById('bonus-100')?.addEventListener('change', aggiornaAltreDetrazioni);
    function aggiornaStatoBottone() {
        if (!bottone) return;
        const target = parseFloat(nettoInput?.value) || 0;
        const ok = target > 0 && Boolean(regione?.value);
        bottone.disabled = !ok;
    }
    nettoInput?.addEventListener('input', ()=>{
        if (parseFloat(nettoInput.value) < 0) nettoInput.value = '';
        aggiornaAltreDetrazioni();
        aggiornaStatoBottone();
    });
    regione?.addEventListener('change', aggiornaStatoBottone);
    document.querySelectorAll('input[name="mensilita"], input[name="modo"], input[name="year"]').forEach((el)=>el.addEventListener('change', ()=>{
            aggiornaAltreDetrazioni();
            aggiornaStatoBottone();
        }));
    bottone?.addEventListener('click', ()=>{
        const payload = encodeURIComponent($771f671a260a0b00$var$encodeParams($771f671a260a0b00$var$raccogliParametri()));
        // replaceState prima di andarsene: riscrive la voce di cronologia del form
        // con i dati dentro, cosi' il tasto indietro del browser ci riporta a un
        // URL da cui il form si puo' ricostruire anche quando la bfcache non tiene.
        window.history.replaceState({}, '', `/calcolo-lordo-da-netto?d=${payload}`);
        window.location.href = `/calcolo-lordo-da-netto/risultati?d=${payload}`;
    });
    // Il testo accanto a una spunta la attiva, ma l'icona del tooltip che sta
    // nella stessa label no: per questo la label non e' associata all'input.
    document.querySelectorAll('[data-toggle]').forEach((span)=>{
        span.addEventListener('click', ()=>{
            const checkbox = document.getElementById(span.dataset.toggle);
            if (!checkbox) return;
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change'));
        });
    });
    // Ricostruisce il form da un URL con i parametri. I radio riemettono `change`
    // perche' pilotano UI dipendente; le checkbox no, perche' i loro handler fanno
    // mutua esclusione e distruggerebbero la combinazione appena ripristinata:
    // lo stato derivato si ricalcola dopo, esplicitamente.
    const applicaParametriAlForm = (query)=>{
        const grezzi = query.has('d') ? $771f671a260a0b00$var$decodeParams(query.get('d')) : Object.fromEntries(query);
        if (!grezzi) return false;
        const presente = (chiave)=>grezzi[chiave] !== undefined && grezzi[chiave] !== '';
        const valore = (id, chiave)=>{
            if (!presente(chiave)) return;
            const el = document.getElementById(id);
            if (el) el.value = grezzi[chiave];
        };
        const spunta = (id, chiave)=>{
            if (!presente(chiave)) return;
            const el = document.getElementById(id);
            if (el) el.checked = $771f671a260a0b00$var$parseBool(grezzi[chiave]);
        };
        const radio = (nome, chiave)=>{
            if (!presente(chiave)) return;
            const el = document.querySelector(`input[name="${nome}"][value="${grezzi[chiave]}"]`);
            if (el) {
                el.checked = true;
                el.dispatchEvent(new Event('change'));
            }
        };
        valore('netto-target', 'netto');
        valore('regione', 'regione');
        valore('comune', 'comune');
        valore('addizionale-comunale', 'addizionaleComunale');
        valore('alinps-dip', 'alinpsDip');
        valore('alinps-dat', 'alinpsDat');
        valore('altre-detrazioni', 'altreDetrazioni');
        valore('imponibile-cervelli', 'imponibileCervelli');
        valore('numero-figli', 'numeroFigli');
        valore('numero-figli-disabili', 'numeroFigliDisabili');
        valore('percentuale-figli', 'percentualeFigli');
        valore('numero-ascendenti', 'numeroAscendenti');
        radio('modo', 'modo');
        radio('mensilita', 'mensilita');
        radio('year', 'year');
        [
            [
                'cuneo-fiscale',
                'cuneoFiscale'
            ],
            [
                'esonero-contributivo',
                'esoneroContributivo'
            ],
            [
                'madre-lavoratrice',
                'madreLavoratrice'
            ],
            [
                'bonus-100',
                'bonus100'
            ],
            [
                'apprendistato',
                'apprendistato'
            ],
            [
                'dipendente-pubblico',
                'dipendentePubblico'
            ],
            [
                'maggiore-15',
                'maggiore15'
            ],
            [
                'modifica-inps',
                'modificaInps'
            ],
            [
                'coniuge-carico',
                'coniugeCarico'
            ],
            [
                'figli-carico',
                'figliCarico'
            ],
            [
                'ascendente-carico',
                'ascendenteCarico'
            ],
            [
                'rientro-cervelli',
                'rientroCervelli'
            ]
        ].forEach(([id, chiave])=>spunta(id, chiave));
        [
            'figli-carico',
            'ascendente-carico',
            'rientro-cervelli'
        ].forEach((id)=>{
            document.getElementById(id)?.dispatchEvent(new Event('change'));
        });
        sincronizzaInps({
            mantieniValori: true
        });
        aggiornaAltreDetrazioni();
        aggiornaStatoBottone();
        return true;
    };
    const query = new URLSearchParams(window.location.search);
    const ripristinato = [
        ...query.keys()
    ].length > 0 && applicaParametriAlForm(query);
    if (!ripristinato) sincronizzaInps();
    aggiornaAltreDetrazioni();
    aggiornaStatoBottone();
    // dopo il ripristino, cosi' l'autocomplete si aggancia a regione e comune gia' scritti
    (0, $9dryX.initComuneAutocomplete)();
    // Ritorno da bfcache: initComuneAutocomplete non viene rieseguito, quindi il
    // campo comune mostrerebbe il testo senza che il modulo lo riconosca, e
    // getComuneSelezionato() resterebbe nullo facendo sparire l'addizionale.
    window.addEventListener('pageshow', (evento)=>{
        if (!evento.persisted) return;
        const q = new URLSearchParams(window.location.search);
        if ([
            ...q.keys()
        ].length === 0) return;
        applicaParametriAlForm(q);
        const comune = document.getElementById('comune');
        if (comune?.value) comune.dispatchEvent(new Event('change'));
    });
}
// ---------------------------------------------------------------------------
// Pagina dei risultati
// ---------------------------------------------------------------------------
const $771f671a260a0b00$var$scrivi = (id, testo)=>{
    const el = document.getElementById(id);
    if (el) el.textContent = testo;
};
// Il ridisegno dei grafici cambia a ogni ricalcolo: l'ascoltatore del resize si
// registra una volta sola e passa sempre dall'ultimo disegnatore buono.
let $771f671a260a0b00$var$ridisegnaGrafici = null;
let $771f671a260a0b00$var$resizeAgganciato = false;


// Risolve e disegna tutto leggendo l'URL corrente. Richiamabile: la modifica
// rapida riscrive l'URL con replaceState e poi ripassa di qui, senza ricaricare.
function $771f671a260a0b00$var$rendiRisultati() {
    const lettura = $771f671a260a0b00$var$leggiParametri();
    if (!lettura) {
        window.location.href = '/calcolo-lordo-da-netto';
        return;
    }
    const { target: target, modo: modo, params: params, grezzi: grezzi } = lettura;
    const esito = (0, $6bbba1924fc499b5$export$5174eaaeb10a35c0)((0, (/*@__PURE__*/$parcel$interopDefault($cNJzb))), params, {
        target: target,
        modo: modo
    });
    document.getElementById('risultato-ok')?.removeAttribute('hidden');
    document.getElementById('nav-sezioni')?.removeAttribute('hidden');
    document.getElementById('fuori-portata-testo')?.setAttribute('hidden', '');
    if (esito.fuoriPortata) {
        document.getElementById('risultato-ok')?.setAttribute('hidden', '');
        document.getElementById('nav-sezioni')?.setAttribute('hidden', '');
        $771f671a260a0b00$var$scrivi('titolo-risultato', "Questo netto \xe8 fuori portata");
        $771f671a260a0b00$var$scrivi('riepilogo-target', `${$771f671a260a0b00$var$euro(target)} \xb7 ${$771f671a260a0b00$var$ETICHETTE_MODO[modo]} \xb7 ${params.mensilita} mensilit\xe0`);
        const testo = document.getElementById('fuori-portata-testo');
        if (testo) {
            testo.hidden = false;
            testo.textContent = `Con questi parametri il netto pi\xf9 alto raggiungibile \xe8 ${$771f671a260a0b00$var$euro(esito.nettoEffettivo)}: ` + `${$771f671a260a0b00$var$euro(target)} richiederebbero una RAL fuori dalla scala del calcolatore.`;
        }
        return;
    }
    const b = esito.breakdown;
    const mensilita = params.mensilita;
    // -- Intestazione ---------------------------------------------------------
    // Il titolo porta la domanda con dentro la cifra chiesta; il sottotitolo le
    // ipotesi del calcolo. La RAL trovata la dice l'hero, e non va ripetuta qui.
    $771f671a260a0b00$var$scrivi('titolo-risultato', `Quanto chiedere per ${$771f671a260a0b00$var$euro(target)} netti ${modo === 'annuo' ? "all'anno" : 'al mese'}`);
    const luogo = grezzi.comune ? `${grezzi.comune}, ${params.regione}` : params.regione;
    const ipotesi = [
        $771f671a260a0b00$var$ETICHETTE_MODO[modo],
        luogo,
        `${mensilita} mensilit\xe0`
    ];
    if (params.year !== '2026') ipotesi.push(`anno ${params.year}`);
    const riepilogo = ipotesi.join(" \xb7 ");
    $771f671a260a0b00$var$scrivi('riepilogo-target', riepilogo.charAt(0).toUpperCase() + riepilogo.slice(1));
    // -- Hero -----------------------------------------------------------------
    $771f671a260a0b00$var$scrivi('ral-richiesta', $771f671a260a0b00$var$euro(esito.ral));
    $771f671a260a0b00$var$scrivi('lordo-mensile', $771f671a260a0b00$var$euro(esito.ral / mensilita));
    // -- Verifica -------------------------------------------------------------
    $771f671a260a0b00$var$scrivi('netto-verificato', $771f671a260a0b00$var$euro(esito.nettoEffettivo));
    // La riga di verifica compare sempre, anche quando il netto chiesto cade in un
    // buco fra due soglie: la conferma va scritta solo se il numero coincide,
    // altrimenti smentisce la nota qui sotto.
    $771f671a260a0b00$var$scrivi('netto-verificato-conferma', esito.esatto ? ', esattamente quello che hai chiesto' : '');
    const notaEsattezza = document.getElementById('nota-esattezza');
    if (notaEsattezza) {
        if (esito.esatto) notaEsattezza.hidden = true;
        else {
            notaEsattezza.hidden = false;
            $771f671a260a0b00$var$scrivi('nota-esattezza-testo', `Nessuna RAL produce esattamente ${$771f671a260a0b00$var$euro(target)}: una soglia fiscale salta quel valore. ` + `${$771f671a260a0b00$var$euro(esito.ral)} \xe8 la prima RAL che lo supera, con ${$771f671a260a0b00$var$euro(esito.nettoEffettivo)}.`);
        }
    }
    const plateauAmpiezza = esito.plateau.max - esito.plateau.min;
    const notaPlateau = document.getElementById('nota-plateau');
    if (notaPlateau) {
        if (plateauAmpiezza >= 5) {
            notaPlateau.hidden = false;
            $771f671a260a0b00$var$scrivi('nota-plateau-testo', `Chiedere fino a ${$771f671a260a0b00$var$euro(esito.plateau.max)} non cambia il netto: ` + `tutte le RAL fra ${$771f671a260a0b00$var$euro(esito.plateau.min)} e ${$771f671a260a0b00$var$euro(esito.plateau.max)} danno ${$771f671a260a0b00$var$euro(esito.nettoEffettivo)}. ` + 'Sopra quella cifra il netto ricomincia a salire.');
        } else notaPlateau.hidden = true;
    }
    // -- Dettaglio ------------------------------------------------------------
    const righe = [
        [
            'det-ral',
            b.ral
        ],
        [
            'det-inps',
            b.inpsDipendente
        ],
        [
            'det-imponibile',
            b.imponibileIrpef
        ],
        [
            'det-irpef-lorda',
            b.irpefLorda
        ],
        [
            'det-detrazione-lavoro',
            b.detrazioneLavoro
        ],
        [
            'det-detrazione-coniuge',
            b.detrazioneConiuge
        ],
        [
            'det-detrazione-figli',
            b.detrazioneFigli
        ],
        [
            'det-detrazione-ascendenti',
            b.detrazioneAscendenti
        ],
        [
            'det-ulteriore-detrazione',
            b.ulterioreDetrazione
        ],
        [
            'det-irpef-netta',
            b.irpefNetta
        ],
        [
            'det-add-regionale',
            b.addizionaleRegionale
        ],
        [
            'det-add-comunale',
            b.addizionaleComunale
        ],
        [
            'det-bonus-100',
            b.bonus100
        ],
        [
            'det-somma-integrativa',
            b.sommaIntegrativa
        ],
        [
            'det-netto-annuo',
            b.nettoAnnuo
        ]
    ];
    righe.forEach(([id, valore])=>$771f671a260a0b00$var$scrivi(id, $771f671a260a0b00$var$euro(valore)));
    $771f671a260a0b00$var$scrivi('dettaglio-ral', $771f671a260a0b00$var$euro(b.ral));
    // -- Composizione annua, accanto al donut ---------------------------------
    $771f671a260a0b00$var$scrivi('comp-netto-annuo', $771f671a260a0b00$var$euro(b.nettoAnnuo));
    $771f671a260a0b00$var$scrivi('comp-inps', $771f671a260a0b00$var$euro(b.inpsDipendente));
    $771f671a260a0b00$var$scrivi('comp-irpef', $771f671a260a0b00$var$euro(b.totaleIrpef));
    // Con 12 mensilita' non c'e' nulla da ripartire: la card sparisce.
    const sezioneMensilita = document.getElementById('sezione-mensilita');
    if (sezioneMensilita) {
        if (b.nettoMensilitaAggiuntiva === null) sezioneMensilita.hidden = true;
        else {
            sezioneMensilita.hidden = false;
            $771f671a260a0b00$var$scrivi('comp-netto-medio', $771f671a260a0b00$var$euro(b.nettoMensileMedio));
            $771f671a260a0b00$var$scrivi('comp-ordinaria', $771f671a260a0b00$var$euro(b.nettoMensilitaOrdinaria));
            $771f671a260a0b00$var$scrivi('comp-aggiuntiva', $771f671a260a0b00$var$euro(b.nettoMensilitaAggiuntiva));
            $771f671a260a0b00$var$scrivi('label-mensilita-aggiuntiva', mensilita >= 14 ? "13\xaa e 14\xaa mensilit\xe0" : "13\xaa mensilit\xe0");
        }
    }
    // -- Costo azienda e aliquota effettiva -----------------------------------
    $771f671a260a0b00$var$scrivi('det-inps-azienda', $771f671a260a0b00$var$euro(b.inpsAzienda));
    $771f671a260a0b00$var$scrivi('det-tfr', $771f671a260a0b00$var$euro(b.trattamentoFineRapporto));
    $771f671a260a0b00$var$scrivi('det-inail', $771f671a260a0b00$var$euro(b.inail));
    $771f671a260a0b00$var$scrivi('det-costo-azienda', $771f671a260a0b00$var$euro(b.costoAzienda));
    $771f671a260a0b00$var$scrivi('aliquota-effettiva', $771f671a260a0b00$var$percento(100 * (1 - b.nettoAnnuo / b.ral)));
    $771f671a260a0b00$var$scrivi('quota-trattenuta', $771f671a260a0b00$var$euro(b.ral - b.nettoAnnuo));
    // -- Soglie ---------------------------------------------------------------
    const boxSoglie = document.getElementById('box-soglie');
    const listaSoglie = document.getElementById('lista-soglie');
    if (boxSoglie && listaSoglie) {
        if (!esito.soglie.length) boxSoglie.hidden = true;
        else {
            boxSoglie.hidden = false;
            listaSoglie.replaceChildren(...esito.soglie.map((s)=>{
                const li = document.createElement('li');
                li.textContent = `Intorno a ${$771f671a260a0b00$var$euro(s.ral)} di RAL il netto annuo scende di ${$771f671a260a0b00$var$euro(s.perdita)}: ${s.cause.join('; ')}.`;
                return li;
            }));
        }
    }
    // -- Sensibilità: curva del netto intorno alla RAL trovata ----------------
    const FINESTRA = 8000;
    const PASSO = 50;
    const punti = [];
    for(let ral = Math.max(0, esito.ral - FINESTRA); ral <= esito.ral + FINESTRA; ral += PASSO){
        const b2 = (0, $jzqAH.computeNetto)((0, (/*@__PURE__*/$parcel$interopDefault($cNJzb))), {
            ...params,
            ral: ral
        });
        punti.push({
            ral: ral,
            netto: (0, $6bbba1924fc499b5$export$ee40bac03751f76c)(b2, modo),
            nettoAnnuo: b2.nettoAnnuo
        });
    }
    // Le soglie si cercano sempre sul netto annuo, con la stessa soglia di
    // rumore del solver: sul mensile un salto vero vale pochi euro e si
    // confonderebbe con l'arrotondamento. Anche l'etichetta e' annua, cosi'
    // combacia con quella dell'elenco piu' sotto.
    const soglieVisibili = [];
    for(let i = 1; i < punti.length; i++){
        const perdita = punti[i - 1].nettoAnnuo - punti[i].nettoAnnuo;
        if (perdita >= 20) soglieVisibili.push({
            ral: punti[i].ral,
            perdita: perdita
        });
    }
    const corpoSensibilita = document.getElementById('tabella-sensibilita');
    if (corpoSensibilita) {
        const scarti = [
            -2000,
            -1000,
            0,
            1000,
            2000,
            5000
        ];
        corpoSensibilita.replaceChildren(...scarti.map((scarto)=>{
            const ral = Math.max(0, esito.ral + scarto);
            const netto = (0, $6bbba1924fc499b5$export$ee40bac03751f76c)((0, $jzqAH.computeNetto)((0, (/*@__PURE__*/$parcel$interopDefault($cNJzb))), {
                ...params,
                ral: ral
            }), modo);
            const tr = document.createElement('tr');
            if (scarto === 0) tr.className = 'highlight';
            const differenza = netto - esito.nettoEffettivo;
            const segno = differenza > 0 ? '+' : differenza < 0 ? "\u2212" : '';
            tr.innerHTML = `<td>${$771f671a260a0b00$var$euro(ral)}</td><td>${$771f671a260a0b00$var$euro(netto)}</td>` + `<td>${scarto === 0 ? 'la tua richiesta' : `${segno}${$771f671a260a0b00$var$numero(Math.abs(differenza))} \u{20AC}`}</td>`;
            return tr;
        }));
    }
    // js/lordoDaNettoCharts.js e' SVG scritto a mano e non porta dipendenze:
    // curva, barre e donut si disegnano appena arriva. Il Sankey e' l'unico
    // grafico che ha davvero bisogno di d3, quindi js/employeeCharts.js (e i
    // suoi 90 kB) si carica dopo e solo per quello.
    const caricaGrafici = ()=>(parcelRequire("cMIZ9"));
    const caricaSankey = ()=>(parcelRequire("jFNsA"));
    if (esito.euroMarginale) {
        $771f671a260a0b00$var$scrivi('resa-marginale', $771f671a260a0b00$var$euro(esito.euroMarginale.nettoAnnuoInPiu));
        $771f671a260a0b00$var$scrivi('resa-percentuale', $771f671a260a0b00$var$percento(esito.euroMarginale.resa * 100));
    }
    // -- Margine di trattativa ------------------------------------------------
    $771f671a260a0b00$var$scrivi('margine-5', $771f671a260a0b00$var$euro(Math.round(esito.ral * 1.05 / 100) * 100));
    $771f671a260a0b00$var$scrivi('margine-10', $771f671a260a0b00$var$euro(Math.round(esito.ral * 1.10 / 100) * 100));
    // -- Passaggio al calcolatore del netto -----------------------------------
    const link = document.getElementById('link-dettaglio-netto');
    if (link) link.href = `/calcolo-stipendio-netto?d=${$771f671a260a0b00$var$parametriPerCalcolatoreNetto(grezzi, esito.ral)}`;
    // -- Confronto fra regioni ------------------------------------------------
    // Ventuno inversioni complete: la tabella si riempie subito, il grafico
    // quando i moduli sono pronti.
    const calcolaRegioni = ()=>{
        const corpo = document.getElementById('tabella-regioni');
        if (!corpo) return null;
        const righe = $771f671a260a0b00$var$REGIONI.map((reg)=>{
            const r = (0, $6bbba1924fc499b5$export$5174eaaeb10a35c0)((0, (/*@__PURE__*/$parcel$interopDefault($cNJzb))), {
                ...params,
                regione: reg
            }, {
                target: target,
                modo: modo
            });
            return r.fuoriPortata ? null : {
                regione: reg,
                ral: r.ral
            };
        }).filter(Boolean).sort((a, b2)=>a.ral - b2.ral);
        if (!righe.length) return null;
        const minima = righe[0].ral;
        corpo.replaceChildren(...righe.map((r)=>{
            const tr = document.createElement('tr');
            if (r.regione === params.regione) tr.className = 'highlight';
            const scarto = r.ral - minima;
            tr.innerHTML = `<td>${r.regione}</td><td>${$771f671a260a0b00$var$euro(r.ral)}</td>` + `<td>${scarto === 0 ? "\u2014" : `+${$771f671a260a0b00$var$numero(scarto)} \u{20AC}`}</td>`;
            return tr;
        }));
        $771f671a260a0b00$var$scrivi('forbice-regionale', $771f671a260a0b00$var$euro(righe[righe.length - 1].ral - minima));
        document.getElementById('box-regioni')?.removeAttribute('hidden');
        return righe;
    };
    const composizione = [
        {
            nome: 'Netto annuo',
            valore: b.nettoAnnuo
        },
        {
            nome: 'Contributi INPS',
            valore: b.inpsDipendente
        },
        {
            nome: 'Ritenute IRPEF',
            valore: b.totaleIrpef
        }
    ];
    const avvia = async ()=>{
        const righeRegioni = calcolaRegioni();
        const grafici = await caricaGrafici();
        $771f671a260a0b00$var$ridisegnaGrafici = ()=>{
            grafici.disegnaDonut('donut-container', 'legend-container', composizione, b.ral);
            grafici.disegnaCurvaNetto('grafico-sensibilita', punti, esito.ral, soglieVisibili, $771f671a260a0b00$var$ETICHETTE_MODO[modo]);
            if (righeRegioni) grafici.disegnaConfrontoRegioni('grafico-regioni', righeRegioni, params.regione);
        };
        $771f671a260a0b00$var$ridisegnaGrafici();
        // I grafici sono disegnati su misura del contenitore: al resize vanno
        // rifatti. Un solo ascoltatore, anche dopo molti ricalcoli.
        if (!$771f671a260a0b00$var$resizeAgganciato) {
            $771f671a260a0b00$var$resizeAgganciato = true;
            let attesaResize = null;
            window.addEventListener('resize', ()=>{
                clearTimeout(attesaResize);
                attesaResize = setTimeout(()=>$771f671a260a0b00$var$ridisegnaGrafici?.(), 200);
            }, {
                passive: true
            });
        }
        const { drawSankeyChart: drawSankeyChart } = await caricaSankey();
        drawSankeyChart(b.ral, b.inpsAzienda, b.trattamentoFineRapporto, b.inail, b.nettoAnnuo, b.inpsDipendente, b.totaleIrpef, b.sommaIntegrativa, b.bonus100);
    };
    if ('requestIdleCallback' in window) requestIdleCallback(avvia, {
        timeout: 1500
    });
    else setTimeout(avvia, 0);
}
// ---------------------------------------------------------------------------
// Modifica rapida
// ---------------------------------------------------------------------------
// Le spunte che la modale sa mostrare come chip. paramName e' la chiave nel
// payload, etichetta il testo della chip.
const $771f671a260a0b00$var$FLAG_MODIFICABILI = [
    {
        paramName: 'cuneoFiscale',
        etichetta: 'Taglio cuneo fiscale'
    },
    {
        paramName: 'bonus100',
        etichetta: "Bonus IRPEF 100 \u20AC"
    },
    {
        paramName: 'esoneroContributivo',
        etichetta: 'Esonero contributivo 2024'
    },
    {
        paramName: 'madreLavoratrice',
        etichetta: 'Madre lavoratrice'
    },
    {
        paramName: 'apprendistato',
        etichetta: 'Contratto di apprendistato'
    },
    {
        paramName: 'dipendentePubblico',
        etichetta: 'Dipendente pubblico'
    },
    {
        paramName: 'maggiore15',
        etichetta: "Azienda con pi\xf9 di 15 dipendenti"
    },
    {
        paramName: 'modificaInps',
        etichetta: 'Modifica aliquote INPS'
    },
    {
        paramName: 'coniugeCarico',
        etichetta: 'Coniuge a carico'
    },
    {
        paramName: 'figliCarico',
        etichetta: 'Figli a carico (dai 21 anni)'
    },
    {
        paramName: 'ascendenteCarico',
        etichetta: 'Genitore o nonno convivente a carico'
    },
    {
        paramName: 'rientroCervelli',
        etichetta: 'Rientro dei cervelli'
    }
];
// Chiave sintetica nel payload con l'elenco delle chip da mostrare. Senza,
// togliere una spunta ne farebbe sparire la chip alla riapertura e non si
// potrebbe piu' riattivare.
const $771f671a260a0b00$var$CHIAVE_CHIP = 'qeFlags';
function $771f671a260a0b00$var$initModificaRapida() {
    const modale = document.getElementById('quickEditModal');
    const form = document.getElementById('quickEditForm');
    const apri = document.getElementById('backArrow');
    const chiudi = document.getElementById('quickEditClose');
    const contenitoreChip = document.getElementById('quick-edit-active-flags');
    const nessunaChip = document.getElementById('quick-edit-no-flags');
    const ausiliari = document.getElementById('quick-edit-aux-fields');
    const nettoInput = document.getElementById('quick-edit-netto');
    const alConfiguratore = document.getElementById('quickEditToConfigurator');
    if (!modale || !form || !apri) return;
    const SELETTORI_FUOCO = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let chipVisibili = [];
    let scrollSalvato = 0;
    const grezziCorrenti = ()=>{
        const query = new URLSearchParams(window.location.search);
        const grezzi = query.has('d') ? $771f671a260a0b00$var$decodeParams(query.get('d')) : Object.fromEntries(query);
        return grezzi ? {
            ...grezzi
        } : {};
    };
    const statoChip = ()=>Object.fromEntries(Array.from(contenitoreChip.querySelectorAll('input[data-quick-flag]')).map((el)=>[
                el.dataset.quickFlag,
                el.checked
            ]));
    const valoreCampo = (id)=>document.getElementById(id)?.value;
    // Imponibile di massima dal target scritto nella modale, per decidere quali
    // campi mostrare mentre l'utente digita.
    const imponibileStimato = ()=>{
        const target = parseFloat(nettoInput?.value) || 0;
        const modo = document.querySelector('input[name="quick-edit-modo"]:checked')?.value || 'busta';
        const mensilita = modo === 'annuo' ? 1 : parseInt(document.querySelector('input[name="quick-edit-mensilita"]:checked')?.value, 10) || 14;
        return target * mensilita * 1.15;
    };
    // Quali chip mostrare: quelle memorizzate nel payload se ci sono, altrimenti
    // le spunte oggi attive.
    const chipDaMostrare = (grezzi)=>{
        const ammesse = new Set($771f671a260a0b00$var$FLAG_MODIFICABILI.map((f)=>f.paramName));
        const memorizzate = String(grezzi[$771f671a260a0b00$var$CHIAVE_CHIP] || '').split(',').map((s)=>s.trim()).filter((s)=>ammesse.has(s));
        if (memorizzate.length) return [
            ...new Set(memorizzate)
        ];
        return $771f671a260a0b00$var$FLAG_MODIFICABILI.filter((f)=>$771f671a260a0b00$var$parseBool(grezzi[f.paramName])).map((f)=>f.paramName);
    };
    // I campi che dipendono da una spunta compaiono solo se quella spunta e' su.
    const disegnaAusiliari = ()=>{
        const grezzi = grezziCorrenti();
        const attivi = statoChip();
        const acceso = (nome)=>nome in attivi ? attivi[nome] : $771f671a260a0b00$var$parseBool(grezzi[nome]);
        const pezzi = [];
        if (acceso('modificaInps')) pezzi.push(`<div class="quick-edit-grid">
        <div class="input-group quick-edit-input-group">
          <label for="quick-edit-alinps-dip">Aliquota INPS dipendente</label>
          <input type="number" id="quick-edit-alinps-dip" min="0" max="40" step="0.01" value="${grezzi.alinpsDip ?? ''}">
        </div>
        <div class="input-group quick-edit-input-group">
          <label for="quick-edit-alinps-dat">Aliquota INPS datore</label>
          <input type="number" id="quick-edit-alinps-dat" min="0" max="50" step="0.01" value="${grezzi.alinpsDat ?? ''}">
        </div>
      </div>`);
        // Le detrazioni per oneri contano solo per incapienza, fra 15.000 e 28.000
        // di imponibile: fuori da quella fascia il campo non serve. Stessa stima
        // grossolana del form, il calcolo vero lo fa il solver.
        if (acceso('bonus100') && imponibileStimato() > 15000 && imponibileStimato() <= 28000) pezzi.push(`<div class="input-group quick-edit-input-group">
        <label for="quick-edit-altre-detrazioni">Detrazioni per oneri</label>
        <input type="number" id="quick-edit-altre-detrazioni" min="0" step="100" value="${grezzi.altreDetrazioni ?? ''}">
      </div>`);
        if (acceso('rientroCervelli')) {
            const scelta = String(grezzi.imponibileCervelli ?? '0.5');
            const opzioni = [
                [
                    '0.5',
                    '50% (regime 2024)'
                ],
                [
                    '0.4',
                    '40% (con figlio minore)'
                ],
                [
                    '0.3',
                    '30% (regime precedente)'
                ],
                [
                    '0.1',
                    '10% (regime precedente, sud)'
                ]
            ];
            pezzi.push(`<div class="input-group quick-edit-input-group">
        <label for="quick-edit-imponibile-cervelli">Percentuale reddito imponibile</label>
        <select id="quick-edit-imponibile-cervelli">
          ${opzioni.map(([v, t])=>`<option value="${v}"${v === scelta ? ' selected' : ''}>${t}</option>`).join('')}
        </select>
      </div>`);
        }
        if (acceso('figliCarico')) pezzi.push(`<div class="quick-edit-grid">
        <div class="input-group quick-edit-input-group">
          <label for="quick-edit-numero-figli">Figli dai 21 ai 29 anni</label>
          <input type="number" id="quick-edit-numero-figli" min="1" max="10" step="1" value="${grezzi.numeroFigli || 1}">
        </div>
        <div class="input-group quick-edit-input-group">
          <label for="quick-edit-numero-figli-disabili">Di cui con disabilit\xe0</label>
          <input type="number" id="quick-edit-numero-figli-disabili" min="0" max="10" step="1" value="${grezzi.numeroFigliDisabili || 0}">
        </div>
      </div>`);
        if (acceso('ascendenteCarico')) pezzi.push(`<div class="input-group quick-edit-input-group">
        <label for="quick-edit-numero-ascendenti">Ascendenti conviventi a carico</label>
        <input type="number" id="quick-edit-numero-ascendenti" min="1" max="6" step="1" value="${grezzi.numeroAscendenti || 1}">
      </div>`);
        ausiliari.innerHTML = pezzi.join('');
    };
    const disegnaChip = ()=>{
        const grezzi = grezziCorrenti();
        chipVisibili = chipDaMostrare(grezzi);
        const perNome = new Map($771f671a260a0b00$var$FLAG_MODIFICABILI.map((f)=>[
                f.paramName,
                f
            ]));
        contenitoreChip.innerHTML = chipVisibili.map((nome)=>{
            const config = perNome.get(nome);
            if (!config) return '';
            return `<label class="inline-checkbox quick-edit-flag">
        <input type="checkbox" data-quick-flag="${nome}"${$771f671a260a0b00$var$parseBool(grezzi[nome]) ? ' checked' : ''}>
        <span>${config.etichetta}</span>
      </label>`;
        }).join('');
        nessunaChip?.classList.toggle('hidden-block', chipVisibili.length > 0);
        contenitoreChip.querySelectorAll('input[data-quick-flag]').forEach((el)=>el.addEventListener('change', disegnaAusiliari));
        disegnaAusiliari();
    };
    const apriModale = ()=>{
        const grezzi = grezziCorrenti();
        if (nettoInput) nettoInput.value = Math.round(parseFloat(grezzi.netto) || 0);
        const modo = $771f671a260a0b00$var$ETICHETTE_MODO[grezzi.modo] ? grezzi.modo : 'busta';
        document.querySelectorAll('input[name="quick-edit-modo"]').forEach((el)=>{
            el.checked = el.value === modo;
        });
        const mensilita = String(grezzi.mensilita || '14');
        document.querySelectorAll('input[name="quick-edit-mensilita"]').forEach((el)=>{
            el.checked = el.value === mensilita;
        });
        disegnaChip();
        modale.classList.add('is-open');
        modale.setAttribute('aria-hidden', 'false');
        scrollSalvato = window.scrollY || 0;
        document.documentElement.classList.add('modal-open');
        document.body.classList.add('modal-open');
        Object.assign(document.body.style, {
            position: 'fixed',
            top: `-${scrollSalvato}px`,
            left: '0',
            right: '0',
            width: '100%'
        });
        // L'originale non porta il fuoco dentro: qui si', altrimenti da tastiera la
        // modale si apre e il fuoco resta sulla pagina sotto.
        (nettoInput || chiudi)?.focus();
    };
    const chiudiModale = ()=>{
        modale.classList.remove('is-open');
        modale.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('modal-open');
        document.body.classList.remove('modal-open');
        [
            'position',
            'top',
            'left',
            'right',
            'width'
        ].forEach((p)=>{
            document.body.style[p] = '';
        });
        window.scrollTo(0, scrollSalvato);
        apri.focus();
    };
    // Cambiare target, modo o mensilita' sposta la fascia di reddito, quindi
    // cambia quali campi ausiliari hanno senso.
    nettoInput?.addEventListener('input', disegnaAusiliari);
    document.querySelectorAll('input[name="quick-edit-modo"], input[name="quick-edit-mensilita"]').forEach((el)=>el.addEventListener('change', disegnaAusiliari));
    apri.addEventListener('click', apriModale);
    chiudi?.addEventListener('click', chiudiModale);
    modale.addEventListener('click', (e)=>{
        if (e.target === modale) chiudiModale();
    });
    document.addEventListener('keydown', (e)=>{
        if (!modale.classList.contains('is-open')) return;
        if (e.key === 'Escape') {
            chiudiModale();
            return;
        }
        if (e.key !== 'Tab') return;
        // Solo gli elementi davvero visibili: i campi ausiliari compaiono e
        // spariscono, e un elemento nascosto agli estremi romperebbe il ciclo.
        const fuocabili = Array.from(modale.querySelectorAll(SELETTORI_FUOCO)).filter((el)=>!el.disabled && el.offsetParent !== null);
        if (!fuocabili.length) return;
        const primo = fuocabili[0];
        const ultimo = fuocabili[fuocabili.length - 1];
        if (e.shiftKey && document.activeElement === primo) {
            e.preventDefault();
            ultimo.focus();
        } else if (!e.shiftKey && document.activeElement === ultimo) {
            e.preventDefault();
            primo.focus();
        }
    });
    // Riscrive il payload nell'URL e ritorna la query, senza toccare i parametri
    // che la modale non gestisce (regione, comune, anno...).
    const scriviPayload = ()=>{
        const grezzi = grezziCorrenti();
        const attivi = statoChip();
        grezzi.netto = String(Math.max(0, Math.round(parseFloat(nettoInput?.value) || 0)));
        grezzi.modo = document.querySelector('input[name="quick-edit-modo"]:checked')?.value || 'busta';
        grezzi.mensilita = document.querySelector('input[name="quick-edit-mensilita"]:checked')?.value || '14';
        grezzi[$771f671a260a0b00$var$CHIAVE_CHIP] = chipVisibili.join(',');
        chipVisibili.forEach((nome)=>{
            grezzi[nome] = attivi[nome] ? '1' : '0';
        });
        // Set se acceso, delete se spento: spegnere una spunta ripulisce i suoi
        // parametri invece di lasciarli appesi nel payload.
        const acceso = (nome)=>nome in attivi ? attivi[nome] : $771f671a260a0b00$var$parseBool(grezzi[nome]);
        const applica = (attivo, coppie)=>coppie.forEach(([chiave, id])=>{
                const v = attivo ? valoreCampo(id) : undefined;
                if (v !== undefined && v !== '') grezzi[chiave] = v;
                else delete grezzi[chiave];
            });
        applica(acceso('modificaInps'), [
            [
                'alinpsDip',
                'quick-edit-alinps-dip'
            ],
            [
                'alinpsDat',
                'quick-edit-alinps-dat'
            ]
        ]);
        applica(acceso('bonus100'), [
            [
                'altreDetrazioni',
                'quick-edit-altre-detrazioni'
            ]
        ]);
        applica(acceso('rientroCervelli'), [
            [
                'imponibileCervelli',
                'quick-edit-imponibile-cervelli'
            ]
        ]);
        applica(acceso('figliCarico'), [
            [
                'numeroFigli',
                'quick-edit-numero-figli'
            ],
            [
                'numeroFigliDisabili',
                'quick-edit-numero-figli-disabili'
            ]
        ]);
        applica(acceso('ascendenteCarico'), [
            [
                'numeroAscendenti',
                'quick-edit-numero-ascendenti'
            ]
        ]);
        const payload = encodeURIComponent($771f671a260a0b00$var$encodeParams(grezzi));
        window.history.replaceState({}, '', `/calcolo-lordo-da-netto/risultati?d=${payload}`);
        return payload;
    };
    form.addEventListener('submit', (e)=>{
        e.preventDefault();
        scriviPayload();
        $771f671a260a0b00$var$rendiRisultati();
        chiudiModale();
        window.scrollTo(0, 0);
    });
    alConfiguratore?.addEventListener('click', ()=>{
        window.location.href = `/calcolo-lordo-da-netto?d=${scriviPayload()}`;
    });
}
// ---------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', ()=>{
    if ($771f671a260a0b00$var$isRisultati) {
        $771f671a260a0b00$var$rendiRisultati();
        $771f671a260a0b00$var$initModificaRapida();
    } else $771f671a260a0b00$var$initForm();
});


//# sourceMappingURL=calcolo-lordo-da-netto.9d8376b9.js.map
